import * as yup from "yup";

const maxHours = 24;

export const getValidationSchema = () => {
  const schema = yup.object().shape({
    selectedWorker: yup
      .object()
      .shape({
        name: yup.string().required(),
      })
      .required()
      .nullable(false),
    districtId: yup.string().required(),
    buildingId: yup.string().required(),
    customerSite: yup.string().when("buildingId", {
      is: "Customer Site",
      then: yup.string().required(),
      otherwise: yup.string().optional(),
    }),
    records: yup.array().of(
      yup.object().shape({
        showFreeForm: yup
          .boolean()
          .default(() => false)
          .required(),
        group: yup.string().test("days validation", function (value) {
          let rowdata = this.parent;
          let result = false;
          let eachDaycount = 0;
          for (let i = 0; i < 7; ++i) {
            const eachDay = `day${i + 1}`;
            if(rowdata[eachDay] && rowdata[eachDay] !=NaN){
              let eachdayValue = 0;
              //console.log("row data:::",rowdata[eachDay]);
              eachdayValue = parseFloat(rowdata[eachDay]);
              eachDaycount += eachdayValue;
            }
             //eachDaycount += rowdata[eachDay];
            //eachDaycount += rowdata[eachDay];
          }
          if (eachDaycount > 0 && value) result = true;

          if (eachDaycount == 0 && !value) result = true;

          return result;
        }),
        //family
        family: yup.string().test("days validation", function (value) {
          let rowdata = this.parent;
          let result = false;
          let eachDaycount = 0;
          for (let i = 0; i < 7; ++i) {
            const eachDay = `day${i + 1}`;
            if(rowdata[eachDay] && rowdata[eachDay] !=NaN){
              let eachdayValue = 0;
              //console.log("row data:::",rowdata[eachDay]);
              eachdayValue = parseFloat(rowdata[eachDay]);
              eachDaycount += eachdayValue;
            }
             //eachDaycount += rowdata[eachDay];
            //eachDaycount += rowdata[eachDay];
          }
          if (eachDaycount > 0 && value) result = true;

          if (eachDaycount == 0 && !value) result = true;

          return result;
        }),
        
        // details: yup.string().when("showFreeForm", {
        //   is: true,
        //   then: yup.string().optional(),
        //   otherwise: yup.string().required(),
        details: yup.string().when(['showFreeForm', 'group'], {
          // details: yup.string().when('group', {
          // is: "Project",
          is: (showFreeForm, group) => showFreeForm ===false &&  group ==='Project',
          then: yup.string().test("days validation", function (value) {
            let rowdata = this.parent;
            let result = false;
            let eachDaycount = 0;
            for (let i = 0; i < 7; ++i) {
              const eachDay = `day${i + 1}`;
              if(rowdata[eachDay] && rowdata[eachDay] !=NaN){
                let eachdayValue = 0;
                eachdayValue = parseFloat(rowdata[eachDay]);
                eachDaycount += eachdayValue;
              }
            }
            if (eachDaycount > 0 && value) result = true;

            if (eachDaycount == 0 && !value) result = true;
            if(!rowdata.details){
              result = false;
            } 
            return result;
          }),
          otherwise: yup.string().optional(),
        }),
        // }),
        // freeForm: yup.string().when("showFreeForm", {
        //   is: true,
        //   then: yup.string().optional(),
        //   otherwise: yup.string().optional(),
        // }),
        freeForm: yup.string().when(['showFreeForm', 'group'], {
          // details: yup.string().when('group', {
          // is: "Project",
          is: (showFreeForm, group) => showFreeForm ===true &&  group ==='Project',
          then: yup.string().test("days validation", function (value) {
            let rowdata = this.parent;
            let result = false;
            let eachDaycount = 0;
            for (let i = 0; i < 7; ++i) {
              const eachDay = `day${i + 1}`;
              if(rowdata[eachDay] && rowdata[eachDay] !=NaN){
                let eachdayValue = 0;
                eachdayValue = parseFloat(rowdata[eachDay]);
                eachDaycount += eachdayValue;
              }
            }
            if (eachDaycount > 0 && value) result = true;

            if (eachDaycount == 0 && !value) result = true;
            if(!rowdata.freeForm){
              result = false;
            } 
            return result;
          }),
          otherwise: yup.string().optional(),
        }),
        // day2: yup.number().typeError("Invalid input").min(0).max(24),
        // day3: yup.number().typeError("Invalid input").min(0).max(24),
        // day4: yup.number().typeError("Invalid input").min(0).max(24),
        // day1: yup.number().typeError("Invalid input").min(0).max(24),
        // day5: yup.number().typeError("Invalid input").min(0).max(24),
        // day6: yup.number().typeError("Invalid input").min(0).max(24),
        // day7: yup.number().typeError("Invalid input").min(0).max(24),
      })
    ),
    weekTotal: yup
      .object()
      .shape({
        day1: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day2: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day3: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day4: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day5: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day6: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day7: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
      })
      .required(),
    // totalHours: yup
    //   .number()
    //   .default(0)
    //   .moreThan(0, `Minimum hours should be greater than 0`),
  });

  return schema;
};

(function () {
  const schema = getValidationSchema();
  schema
    .isValid({
      records: [
        {
          family: "Ok",
          group: "Project",
          //details: "",
          freeForm: "Ok",
          showFreeForm: false,
          day1: "0",
          day2: "0",
          day3: "2",
          day4: "0",
          day5: "0",
          day6: "0",
          day7: "1",
        },
      ],
    })
    .then((res) => console.log("Validation", res))
    .catch((e) => console.error("Validation", e));
})();
